var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "501px",
    height: "229px",
    viewBox: "0 0 501 229",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.48828125 0.48828125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0 0.70917934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.345 149.426C391.175 132.994 496.377 92.8905 492.321 59.8531C488.264 26.8157 376.485 13.3546 242.655 29.7868C108.825 46.2191 3.62268 86.3222 7.67916 119.36C11.7357 152.397 123.515 165.858 257.345 149.426Z",
    id: "Oval-20",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#979797",
    strokeWidth: 0.9765625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.972 140.006C381.664 124.573 480.795 89.5634 477.388 61.8097C473.98 34.0561 369.324 24.0683 243.632 39.5013C117.94 54.9343 18.8092 89.944 22.2169 117.698C25.6247 145.451 130.281 155.439 255.972 140.006Z",
    id: "Oval-20-Copy",
    fill: "#000002",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.272 227.291C314.692 227.291 370.956 183.717 390.153 123.539C390.594 122.156 388.151 123.801 383.557 125.209C375.613 127.644 360.538 131.883 337.792 136.61C306.676 143.078 262.029 149.611 246.794 151.426C231.015 153.306 198.833 155.028 171.062 155.985C154.699 156.548 142.484 157.495 133.435 157.172C127.126 156.947 120.77 154.711 122.301 157.172C148.597 199.439 194.908 227.291 248.272 227.291Z",
    id: "Oval-19",
    fill: "#6758FF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.021 215.196C287.955 215.196 309.337 197.581 309.337 194.338C309.337 191.095 287.955 202.283 258.021 202.283C228.088 202.283 198.242 199.04 198.242 202.283C198.242 204.328 213.382 210.434 231.868 212.871C242.696 214.298 246.964 215.196 258.021 215.196Z",
    id: "Oval-24",
    fill: "#FF7FA7",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLarge);
export default __webpack_public_path__ + "static/media/logo_large.f853ad2945c4125fc86316456d6a9969.svg";
export { ForwardRef as ReactComponent };